import DIMENSIONS from '@app/config/dimensions';
import { useRestaurantContext } from '@app/pages/Restaurant/context';
import { Menu } from '@app/types';
import React, { useEffect, useRef, useState } from 'react';
import classes from './styles.module.css';
import cls from 'classnames';

type Props = {
  menus: Menu[];
  activedMenu: Menu | null;
  onSelectMenuToScroll: (menu: Menu) => void;
};

function getLeftOffsetOfMenu(menu: Menu) {
  const element = document.getElementById(`scroller-item-${menu.id}`);
  if (!element) return null;
  const scrollLeft = element.offsetLeft - 20 > 0 ? element.offsetLeft - 20 : element.offsetLeft;
  return scrollLeft;
}

export default function MenusHorizontalScroller({ menus, activedMenu, onSelectMenuToScroll }: Props) {
  const { primaryColor } = useRestaurantContext();

  const scrollerBoxRef = useRef<HTMLDivElement>(null);
  const containerRef = useRef<HTMLDivElement>(null);

  const shouldAvoidScroll = useRef(false);
  const [shouldDisplayScroller, setShouldDisplayScroller] = useState(false);

  useEffect(() => {
    if (menus.length === 0) return;

    const element = document.getElementById(`menu-card-${menus[0].id}`);
    const scrollLimitToDisplay =
      (element?.offsetTop ?? 300) - DIMENSIONS.APP_BAR.HEIGHT - DIMENSIONS.MAIN_PAGE.SEARCH_AND_SCROLLER_BOX_HEIGHT;

    function listenerBodyScroll() {
      if (!containerRef.current) return;

      const offsetTop = window.scrollY;
      if (offsetTop > scrollLimitToDisplay) {
        setShouldDisplayScroller(true);
      } else {
        setShouldDisplayScroller(false);
      }
    }

    window.addEventListener('scroll', listenerBodyScroll);
    return () => {
      window.removeEventListener('scroll', listenerBodyScroll);
    };
  }, [menus.length]);

  useEffect(() => {
    if (activedMenu && scrollerBoxRef.current && !shouldAvoidScroll.current) {
      const offsetLeft = getLeftOffsetOfMenu(activedMenu);
      if (offsetLeft) {
        scrollerBoxRef.current.scrollLeft = offsetLeft;
      }
    }
  }, [activedMenu]);

  function handleClickMenuScroll(menu: Menu) {
    shouldAvoidScroll.current = true;
    onSelectMenuToScroll(menu);
    const offsetLeft = getLeftOffsetOfMenu(menu);
    if (scrollerBoxRef.current && offsetLeft) scrollerBoxRef.current.scrollLeft = offsetLeft;
    setTimeout(() => (shouldAvoidScroll.current = false), 1000);
  }

  return (
    <div
      ref={containerRef}
      className={cls(classes.container, shouldDisplayScroller && classes.animateOpacity)}
      style={{
        top: DIMENSIONS.APP_BAR.HEIGHT,
        height: DIMENSIONS.MAIN_PAGE.SEARCH_AND_SCROLLER_BOX_HEIGHT,
        // display: shouldDisplayScroller ? 'block' : 'none',
      }}
    >
      <div className={classes.scrollerBox} ref={scrollerBoxRef}>
        {menus.map((menu) => {
          return (
            <div
              key={menu.id}
              id={`scroller-item-${menu.id}`}
              className={classes.scrollerItem}
              style={{ color: activedMenu?.id === menu.id ? primaryColor : 'inherit' }}
              onClick={() => handleClickMenuScroll(menu)}
            >
              <span>{menu.nome}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
